import { render, staticRenderFns } from "./CloseRegister.vue?vue&type=template&id=8a125fe2&scoped=true&"
import script from "./CloseRegister.vue?vue&type=script&lang=js&"
export * from "./CloseRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a125fe2",
  null
  
)

export default component.exports